import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'dialog-doubles-team',
  templateUrl: './dialogChangeDoublesName.component.html',
  styleUrls: ['dialogChangeDoublesName.component.scss']
})
export class DialogDoublesNameComponent {
  public teamName: string;

  constructor(private dialogRef: MatDialogRef<DialogDoublesNameComponent>,
    private http: HttpClient, private usrSvc: UserService) {
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public save() {
    this.http.post(`/doubles/name`, { teamName: this.teamName }).subscribe(
      (resp) => {
        console.log('successfully updated name');
        this.dialogRef.close(this.teamName);
      },
      (err) => {
        console.error('could not update name');
      }
    )
  }
}